import { Component, Input, EventEmitter, Output, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { JoinSessionVM } from '../../models/JoinSessionVM';
import { FormBuilder } from '@angular/forms';
import { CommsService } from '../../../services/comms.service';
import { JoinSessionResponseVM } from '../../models/JoinSessionResponseVM';
import { SessionType } from '../../models/SessionType';
import { SessionStatus } from '../../models/SessionStatus';

declare function setupAudio(): any;
declare function stopAudio(): any;

@Component({
  selector: 'step-2-mic',
  templateUrl: './step-2-mic.component.html'
})
export class Step2MicComponent implements AfterViewInit {

  @Output() OnChanged: EventEmitter<number> = new EventEmitter();

  ngAfterViewInit(): void {
    setupAudio();
  }

  setDeviceSetupStage1() {
    this.OnChanged.emit(1);
  }

  setDeviceSetupStage3() {
    stopAudio();
    this.OnChanged.emit(3);
  }

}
